module.exports = "<div class=\"card\" style=\"margin-bottom: 65px;\">\n  <div class=\"card-header\">\n    <nav aria-label=\"breadcrumb\">\n      <ol class=\"breadcrumb m-0 p-0\">\n        <li class=\"breadcrumb-item active\" aria-current=\"page\">\n          <i class=\"fa fa-wrench\"></i>\n          <span>Administration</span>\n        </li>\n      </ol>\n    </nav>\n  </div>\n  <app-administration-io></app-administration-io>\n  <app-administration-maintenance></app-administration-maintenance>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/components/administration/administration.component.html
// module id = 1108
// module chunks = 1